<template>
    <v-container class="mobile-login" fluid>
        <vue-headful :title="$t('header.login') + $t('title')"></vue-headful>
        <HkiaraceBannerFrame :label="$t('login.title')">
            <v-container class="form-container">
                <v-row>
                    <v-col>
                        <v-text-field outlined
                                      :label="$t('login.username')"
                                      :placeholder="$t('login.username')"
                                      v-model="username"
                                      autocomplete="username"
                                      :disabled="defaultUsername"
                                      @keyup.enter="login"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field outlined
                                      :label="$t('login.password')"
                                      :placeholder="$t('login.password')"
                                      v-model="password"
                                      autocomplete="current-password"
                                      @keyup.enter="login"
                                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                      :type="showPassword ? 'text' : 'password'"
                                      @click:append="showPassword = !showPassword"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn block
                               color="primary"
                               @click="login"
                               :disabled="!username || !password">{{$t('header.login')}}</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-left">
                        <router-link :to="{name: 'mobile-reset-password-init'}" class="forgot-pw-link">{{$t('login.forgot_password')}}</router-link>
                    </v-col>
                    <v-col class="text-right">
                        <router-link :to="{name: 'register'}" class="forgot-pw-link">{{$t('header.register')}}</router-link>
                    </v-col>
                </v-row>
            </v-container>
        </HkiaraceBannerFrame>

        <b-modal id="remindChangePasswordModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc
                 centered
                 siz="sm">
            <b-container class="remind-change-password-container">
                <b-row class="mb-3">
                    <b-col class="remind-change-password-title text-center">
                        {{$t('remind_change_password.modal_title')}}
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col class="remind-change-password-content">
                        {{$t('remind_change_password.modal_content')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="remind-change-password-btn"
                                  block
                                  @click="$router.push({name: 'my-account'})">
                            {{$t('remind_change_password.skip')}}
                        </b-button>
                    </b-col>
                    <b-col>
                        <b-button class="remind-change-password-btn"
                                  block
                                  variant="primary"
                                  @click="$router.push({name: 'change-password'})">
                            {{$t('remind_change_password.change_password')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </v-container>
</template>

<script>

    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";
    export default {
        name: 'MobileLogin',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                defaultUsername: this.$route.params.username,
                username: this.$route.params.username || '',
                password: '',
                showPassword: false,
            };
        },
        watch: {
            currentUser(newVal, oldVal) {
                if (!oldVal.id && newVal.id) {
                    if (this.$route.query.after) {
                        this.$router.replace({path: this.$route.query.after});
                    } else {
                        this.$cookie.set('jwt', newVal.token, {expires: '10Y', samesite: 'Strict', secure: true});
                        this.$router.replace({name: 'mobile-login-success', params: {jwt: newVal.token}});
                    }
                }
            },
        },
        computed: {
            currentUser() {
                return this.$store.state.user;
            },
        },
        methods: {
            login() {
                if (this.username && this.password) {
                    let deviceToken = this.$cookie.get('DT');

                    this.$callAPI('hkiarace/login/', {
                        username: this.username,
                        password: this.password,
                        device_token: deviceToken,
                    }, function (response) {
                        this.$storeDispatch('getMe');
                    }, function (response) {
                        if (response.status === 401) {
                            if (response.body.msg === 'locked_account_error') {
                                this.$showAlertMessage(this.$t('login.locked_account_error'));
                            } else if (response.body.msg === 'disabled_account_error') {
                                this.$showAlertMessage(this.$t('login.disabled_account_error'));
                            } else {
                                this.$showAlertMessage(this.$t('login.wrong_password'))
                            }
                        } else {
                            if (response.body.verify_email) {
                                this.$router.push({name: 'mobile-email-verify-init'});
                            } else if (response.body.verify_device) {
                                this.$router.push({name: 'mobile-device-verify', query: {after: this.$route.query.after}});
                            }
                        }
                    });

                    this.password = '';
                }
            },
        }
    }
</script>

<style lang="less">
    .mobile-login {
        .form-container {
            padding: 60px 10% 24px 10%;
            background-color: white;

            .v-input {
                border-radius: 0;
            }
        }

        .forgot-pw-link {
            color: #798188;
        }
    }

    .remind-change-password-container {
        padding: 50px;

        .remind-change-password-title {
            font-size: 2rem;

        }

    }
</style>
